export default "__VITE_ASSET__BIgKUglP__"